import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AuthUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  avatarUrl?: string | null;
}

export interface AuthOrg {
  id: string;
  name: string;
  slug: string;
  role?: string;
}

interface AuthState {
  user: AuthUser | null;
  organization: AuthOrg | null;
  accessToken: string | null;
  refreshToken: string | null;
  setAuth: (payload: {
    user: AuthUser;
    organization: AuthOrg | null;
    accessToken: string;
    refreshToken: string;
  }) => void;
  setUser: (user: AuthUser) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  clearAuth: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      organization: null,
      accessToken: null,
      refreshToken: null,
      setAuth: ({ user, organization, accessToken, refreshToken }) => {
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        if (organization) localStorage.setItem("organizationId", organization.id);
        set({ user, organization, accessToken, refreshToken });
      },
      setUser: (user) => set({ user }),
      setTokens: (accessToken, refreshToken) => {
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        set({ accessToken, refreshToken });
      },
      clearAuth: () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("organizationId");
        set({ user: null, organization: null, accessToken: null, refreshToken: null });
      },
      isAuthenticated: () => !!get().accessToken && !!get().user,
    }),
    { name: "panelflow-auth", partialize: (s) => ({ user: s.user, organization: s.organization, accessToken: s.accessToken, refreshToken: s.refreshToken }) }
  )
);
